import { RefObject, useCallback, useEffect, useState } from 'react';

export const useHiddenBadges = (badgesCount: number, container: RefObject<HTMLDivElement>) => {
  const [hiddenBadgesCount, setHiddenBadgesCount] = useState(0);

  const updateHiddenBadges = useCallback(() => {
    const badgesContainer = container.current;
    if (!badgesContainer) return;
    const placeForBadges = Math.floor(badgesContainer.getBoundingClientRect().width / 90);

    setHiddenBadgesCount(Math.max(badgesCount - placeForBadges, 0));
  }, [badgesCount, container]);

  useEffect(() => {
    updateHiddenBadges();
    window.addEventListener('resize', updateHiddenBadges);
    return () => window.removeEventListener('resize', updateHiddenBadges);
  }, [updateHiddenBadges]);

  return hiddenBadgesCount;
};
